<template>
  <div class="applyinfo" :style="'height:'+winHeight+'px;'">
    <div class="step_one">
      <van-steps :active="step_active" active-color="#45B9BC">
        <van-step style="color:#45B9BC;">身份验证</van-step>
        <van-step>个人信息</van-step>
        <van-step>证件上传</van-step>
      </van-steps>
    </div>

    <div class="tech_box">
      <ul>
        <li>
          <div data-v-0b7c2ccb class="van-cell van-field">
            <div class="van-cell__title van-field__label">
              <span>性别</span>
            </div>
            <div class="van-cell__value" @click="showPopup"> 
              <div class="van-field__body">
                <span v-if="info.gender == 1">男</span>
                <span v-if="info.gender == 2">女</span>
              </div>
            </div>
          </div>
        </li>

        <li>
          <van-field v-model="info.age" label="年龄" placeholder="请输入年龄" />
        </li>
        <li>
          <van-field v-model="info.workingtime" label="工作经验(年)" placeholder="请输入工作经验" />
        </li>
        <!-- <li>
          <van-field v-model="username" label="服务项目" placeholder />
        </li>-->
        <li>
          <span class="grjs_label">个人介绍</span>
          <van-cell-group>
            <van-field
              v-model="info.desc"
              rows="2"
              autosize
              type="textarea"
              maxlength="150"
              placeholder="请输入留言"
              show-word-limit
            />
          </van-cell-group>
        </li>
      </ul>
    </div>

    <van-popup v-model="show" position="bottom">
      <van-picker :columns="genders" @change="onChange" />
    </van-popup>
    <div class="btn_box">
      <button class="next_btn" @click="goupload()">下一步</button>
    </div>
  </div>
</template>

<script>
import storage from '@/common/storage'
export default {
  name: "applyinfo",
  components: {},
  data() {
    return {
      step_active: 1,
      winHeight: document.body.clientHeight,
      genders: ['男', '女'],
      show: false,
      info:{
        desc: "",
        gender:1,
        age:'',
        workingtime:''
      }
    };
  },
  created() {

  },
  methods: {
    onChange(picker, value, index) {
      if(index == 0){
        this.info.gender = 1;
      }
      if(index == 1){
        this.info.gender = 2;
      }
    },
    showPopup() {
      this.show = true;
    },
    goupload(){
      if(this.info.gender == 0){
        this.$toast('请选择性别');
      }
      if(!this.info.age){
        this.$toast('请输入年龄');
      }
      if(!this.info.workingtime){
        this.$toast('请输入工作经验');
      }
      if(!this.info.desc){
        this.$toast('请输入个人介绍');
      }
      storage.s_setItem('applyInfo',this.info);

      this.$router.push('/upload');

    }
  }
};
</script>
<style scoped>
.van-cell-group .van-cell,
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: 0;
}
.van-cell {
  border-bottom: 1px solid #eee;
}
.applyinfo {
  background-color: white;
}
.bz {
  position: absolute;
}
.van-step--horizontal .van-step__circle-container {
  top: 45px !important;
}
.van-step--horizontal .van-step__line {
  top: 45px !important;
}
.btn_box {
  text-align: center;
}
.next_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 5rem;
  margin-top: 2.5rem;
  font-size: 0.9rem;
}
.van-steps--horizontal {
  padding: 0.75rem 2rem;
}
.tech_box li {
  background-color: white;
  padding: 0.1rem 1.25rem;
}
.van-button--primary {
  background-color: white;
  border: 1px solid #45b9bc;
  border-radius: 5px;
  color: #45b9bc;
}
.van-step--horizontal .van-step__title {
  font-size: 0.7rem;
}
.grjs_label {
  padding: 10px 16px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/applyinfo.vue